import React from 'react';
import { ToolTip, ToolTipText } from './styled-components';

export const Tooltip = ({ children, text }) => (
  <ToolTip>
    {children}
    <ToolTipText>{text}</ToolTipText>
  </ToolTip>
);
